export default "__VITE_ASSET__B6y1AELS__"